import { render, staticRenderFns } from "./clientTag.vue?vue&type=template&id=b089852c&scoped=true&"
import script from "./clientTag.vue?vue&type=script&lang=js&"
export * from "./clientTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b089852c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b089852c')) {
      api.createRecord('b089852c', component.options)
    } else {
      api.reload('b089852c', component.options)
    }
    module.hot.accept("./clientTag.vue?vue&type=template&id=b089852c&scoped=true&", function () {
      api.rerender('b089852c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/clientTag/clientTag.vue"
export default component.exports